module.exports = __webpack_public_path__ + "img/leo.763b67da.jpg";